import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import { RiFileExcel2Line } from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
// import ReactTable from 'react-table';
// import React from "react";
// import ReactDOM from "react-dom"
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";
import { NumberWithCommas } from "../../share/NumberWithCommas";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report1913() {
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNew BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }
    const [Borrow1913data, setBorrow1913data] = useState([]);
    const [thYearSelected, setThYearSelected] = useState(new Date().getFullYear() + 543)

    async function GetV1913() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/BorrowReports/getV1913", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        setBorrow1913data(data.dataenum)

    }

    const [Re1913yeardata, setRe1913yeardata] = React.useState([]);
    async function getR1913year() {
        const res = await fetch("/api/BorrowReports/getyear1913")
        const Re1913yeardata = await res.json()
        setRe1913yeardata(Re1913yeardata.dataenum)
        console.log(Re1913yeardata)
    }

    

    /*async function GetV1913() {
        const response1913 = await fetch("/api/BorrowReports/getV1913")
        const Borrow1913data = await response1913.json()
        setBorrow1913data(Borrow1913data.dataenum);
        console.log(Borrow1913data)
    }*/

    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ลำดับที่', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'หน่วยงาน', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จัดสรรตามร้อยละของสปก. และตวามต้องการกู้ยืม เงินกองทุนฯปีงบประมาณ พ.ศ. ' + thYearSelected, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'อนุมัติปีงบประมาณ พ.ศ. ' + thYearSelected, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ทำสัญญาปีงบประมาณ  พ.ศ. ' + thYearSelected, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'อนุมัติและทำสัญญาปีงบประมาณ พ.ศ. ' + thYearSelected, fillColor: '#cccccc', bold: true, alignment: 'center' }],
    //     [{}, {}, { text: '(บาท)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(บาท)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(บาท)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(บาท)', fillColor: '#cccccc', bold: true, alignment: 'center' }]];
    //     Borrow1913data.forEach(function (item, i) {
    //         var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.site, alignment: 'left' }, { text: (NumberWithCommas(item.demandBorrow)), alignment: 'right' }, { text: (NumberWithCommas(item.amountApprove)), alignment: 'right' }, { text: (NumberWithCommas(item.contractBudget)), alignment: 'right' }, { text: (NumberWithCommas(item.approveContract)), alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'การจัดสรรเป้าหมายการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน ประจำปีงบประมาณ พ.ศ. ' + thYearSelected, bold: true, alignment: 'center', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto',],
    //                     body: tablebody
    //                 },
    //             }],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R1913')
    // }


    useEffect(() => {
        GetV1913()
        getR1913year()
    }, [thYearSelected])

    let sum1 = Borrow1913data.reduce(function (prev, current) {
        return prev + +current.demandBorrow
    }, 0);
    let sum2 = Borrow1913data.reduce(function (prev, current) {
        return prev + +current.amountApprove
    }, 0);
    let sum3 = Borrow1913data.reduce(function (prev, current) {
        return prev + +current.contractBudget
    }, 0);
    let sum4 = Borrow1913data.reduce(function (prev, current) {
        return prev + +current.approveContract
    }, 0);

    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 className='mt-1 text-center' >
                        ประจำปีงบประมาณ พ.ศ.
                    </h3>
                    <Input
                        style={{ borderColor: "#FFFFFF", width: "10%", paddingTop: '0px', fontSize: '1.75rem' }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {Re1913yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div> */}
                <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ประจำปีงบประมาณ พ.ศ.</span>
                    <Input
                        // className='report-select-one-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {/* <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option> */}
                        {Re1913yeardata?.map((item, i) => (
                            <option className='option-style' value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                     
                    </Input>
                </div>

                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV1913?thYear=${thYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR1913?thYear=${thYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                 <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV1913?thYear=${thYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR1913?thYear=${thYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>


                <div className="report-wrapper">
                    <Table className="styled-table text-center" bordered striped hover>
                        <thead className='styles-thead'>
                            <tr>
                                <th rowSpan="2" className='text-center'>
                                    ลำดับ
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    หน่วยงาน
                                </th>
                                <th className='text-center'>
                                    จัดสรรตามร้อยละของสปก. และตวามต้องการกู้ยืมเงินกองทุนฯปีงบประมาณ พ.ศ. {thYearSelected}
                                </th>
                                <th className='text-center'>
                                    อนุมัติปีงบประมาณ พ.ศ. {thYearSelected}
                                </th>
                                <th className='text-center'>
                                    ทำสัญญาปีงบประมาณ  พ.ศ. {thYearSelected}
                                </th>
                                <th className='text-center'>
                                    อนุมัติและทำสัญญาปีงบประมาณ พ.ศ. {thYearSelected}
                                </th>

                            </tr>
                            <tr>
                                <th className='text-center'>
                                    บาท
                                </th>
                                <th className='text-center'>
                                    บาท
                                </th>
                                <th className='text-center'>
                                    บาท
                                </th>
                                <th className='text-center'>
                                    บาท
                                </th>

                            </tr>
                        </thead>
                        <tbody> {Borrow1913data.map((item, i) => (
                            <tr key={i}>
                                <th scope="row" className='text-center'>
                                    {i + 1}
                                </th>
                                <td className='text-start'>
                                    {item.site}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.demandBorrow)}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.amountApprove)}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.contractBudget)}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.approveContract)}
                                </td>

                            </tr>
                        ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th scope="row" colSpan="2">
                                    รวมทั้งสิ้น
                                </th>
                                <td className='text-end'>
                                    {NumberWithCommas(sum1)}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(sum2)}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(sum3)}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(sum4)}
                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                </div>


            </div>

        </Container>
    );


}